import { IonCol, IonRow, IonText } from "@ionic/react";

import { BasicSubscriptionPricing } from "./BasicSubscriptionPricing";
import {
  EssentialSubscriptionPricing,
  PremiumSubscriptionPricing,
} from "./PremiumSubscriptionPricing";

import "./Pricing.css";
// eslint-disable-next-line
export const Pricing: React.FC<{ id?: string }> = ({ id }) => (
  <IonRow className="pricing-row" id={id}>
    <IonCol size="12">
      <IonRow>
        <IonText color="marketing-gold">
          <h1 className="ion-no-padding">Pricing</h1>
        </IonText>
      </IonRow>
      <IonRow>
        <IonText className="pricing-intro">
          We wish that myFirePlane could be free. The truth is that putting
          things on the inter-web costs money. We never see or save your payment
          information but are notified that you have paid. We use Stripe to
          protect your information from fraud and abuse.
        </IonText>
      </IonRow>
      <IonRow className="white-cards ion-justify-content-center ion-custom-gap-32">
        <IonCol className="pricing-card-slot" size="12" sizeMd="auto">
          <BasicSubscriptionPricing />
        </IonCol>
        <IonCol className="pricing-card-slot" size="12" sizeMd="auto">
          <EssentialSubscriptionPricing />
        </IonCol>
        <IonCol className="pricing-card-slot" size="12" sizeMd="auto">
          <PremiumSubscriptionPricing />
        </IonCol>
      </IonRow>
    </IonCol>
  </IonRow>
);
